import { Component, Input, OnInit } from '@angular/core';
import { WindowService } from '../../shared/services/window.service';
import { LeaderLinesData } from './leader-lines.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'leader-lines',
  templateUrl: './leader-lines.component.html',
  styleUrls: ['./leader-lines.component.scss'],
})
export class LeaderLinesComponent implements OnInit {
  @Input() data: LeaderLinesData[];

  constructor(private window: WindowService) {}

  ngOnInit(): void {
    const [data] = checkInputsForText([this.data]);

    this.data = data;
  }
}
